import { useState } from "react";
import { useAccount } from "./useAccount";
import { Avviso, Bottone, Campo, LinkTesto, PaginaAccount, Scheda } from "./ui";
import { C } from "../theme/tokens";
import { traccia } from "../consenso/tracciamento";

export default function AccessoPage({ onNavigate, next }) {
  const { imposta, api } = useAccount();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errore, setErrore] = useState(null);
  const [nonVerificato, setNonVerificato] = useState(false);
  const [avviso, setAvviso] = useState(null);
  const [inCorso, setInCorso] = useState(false);

  const invia = async (e) => {
    e.preventDefault();
    setInCorso(true); setErrore(null); setAvviso(null);
    try {
      const profilo = await api.accesso(email, password);
      imposta(profilo);
      traccia.accesso();
      // Dopo l'accesso si va a lavorare: l'area clienti resta a portata di
      // mano nella barra laterale, e ci si torna solo se era la meta.
      onNavigate(next === "account" ? "account" : "anonymize");
    } catch (err) {
      setErrore(err.message);
      setNonVerificato(err.codice === "non_verificato");
    } finally {
      setInCorso(false);
    }
  };

  const reinvia = async () => {
    try {
      const r = await api.reinviaVerifica(email);
      setAvviso(r.messaggio || "Email inviata.");
    } catch (err) {
      setErrore(err.message);
    }
  };

  return (
    <PaginaAccount titolo="Accedi" sottotitolo="Entra nell'area clienti di OBSCURA." onBack={() => onNavigate("landing")}>
      <Scheda>
        <form onSubmit={invia}>
          <Campo etichetta="Email" tipo="email" valore={email} onChange={setEmail} autoComplete="email" />
          <Campo etichetta="Password" tipo="password" valore={password} onChange={setPassword} autoComplete="current-password" />
          {errore && <Avviso tipo="errore">{errore}</Avviso>}
          {nonVerificato && !avviso && (
            <p style={{ margin: "0 0 14px", fontSize: 13, color: C.textNum }}>
              Non trovi l&apos;email? <LinkTesto onClick={reinvia}>Reinvia il link di conferma</LinkTesto>
            </p>
          )}
          {avviso && <Avviso tipo="ok">{avviso}</Avviso>}
          <Bottone tipo="submit" pieno disabilitato={inCorso}>{inCorso ? "Accesso in corso..." : "Entra"}</Bottone>
        </form>
      </Scheda>
      <p style={{ fontSize: 13, color: C.textNum, textAlign: "center", margin: 0 }}>
        <LinkTesto onClick={() => onNavigate("password")}>Password dimenticata?</LinkTesto>
        <span style={{ margin: "0 10px" }}>·</span>
        <LinkTesto onClick={() => onNavigate("registrazione")}>Crea un account</LinkTesto>
      </p>
    </PaginaAccount>
  );
}
